// useSessionRefresh.js
import { useEffect } from "react";
import Cookies from "js-cookie";

// Refresh the token expiration on user activity (10 min)
export const useSessionRefresh = () => {
  const refreshTokenExpiration = () => {
    const expirationTime = new Date(new Date().getTime() + 10 * 60 * 1000); // 10 min
    const userDetails = Cookies.get("user_details");
    if (userDetails) {
      Cookies.set("user_details", Cookies.get("user_details"), {
        expires: expirationTime,
      });
    }
  };

  useEffect(() => {
    window.addEventListener("mousemove", refreshTokenExpiration);
    window.addEventListener("keydown", refreshTokenExpiration);

    return () => {
      window.removeEventListener("mousemove", refreshTokenExpiration);
      window.removeEventListener("keydown", refreshTokenExpiration);
    };
  }, []);
};
